import { useState } from 'react'
import { Theme, useTheme } from '@mui/material'
import ZRadio from '../components/ZRadio'
import ZButton from '../components/ZButton'
import { CategorySelectionIcon } from '../assets/icons'
import ZIcon from '../components/ZIcon'
import { CategorisationTreeOption, CategorisationTreeQuestion } from '../types'
import ZText from '../components/ZText'
import ZBottomContainer from '../components/ZBottomContainer'
import ZScreenContainer from '../components/ZScreenContainer'
import Header from '../components/Header'

const CategorySelectionForm = ({
  rootQuestion,
  onSelectOption,
  onCancel,
}: {
  rootQuestion: CategorisationTreeQuestion
  onSelectOption: (option: CategorisationTreeOption) => void
  onCancel: () => void
}) => {
  const [selectedOptionId, setSelectedOptionId] = useState<string>()

  const theme = useTheme<Theme>()

  const options = rootQuestion.options ?? []

  return (
    <ZScreenContainer>
      <Header title="Self Categorisation" />

      <ZIcon
        Icon={CategorySelectionIcon}
        fill="none"
        stroke={theme.palette.primary.main}
        title="Risk warning icon"
        style={{ alignSelf: 'center' }}
      />

      <ZText>{rootQuestion.label}</ZText>

      <ZRadio
        box
        options={options.map(option => ({
          value: option.id,
          label: option.label,
          subLabel: option.subLabel ?? undefined,
        }))}
        onChange={event => setSelectedOptionId(event.target.value)}
        style={{ marginTop: '1rem' }}
      />

      <ZBottomContainer>
        <ZButton
          onClick={() =>
            onSelectOption(options.find(o => o.id === selectedOptionId)!)
          }
          disabled={!selectedOptionId}
        >
          Next
        </ZButton>

        <ZButton onClick={() => onCancel()}>
          I wish to leave this investment journey
        </ZButton>
      </ZBottomContainer>
    </ZScreenContainer>
  )
}

export default CategorySelectionForm
